export interface CountryCode {
    country: string;
    countryTranslationKey: string;
    shortName: string;
    code: string;
}

export const usCountryCode: CountryCode = {
    country: 'United States of America',
    countryTranslationKey: 'ManagePhoneNumbersPhoneEntry.UnitedStates',
    shortName: 'US',
    code: '+1'
};

// Country codes available in the phone number text field
export const countryCodes: CountryCode[] = [
    {
        country: 'Canada',
        countryTranslationKey: 'ManagePhoneNumbersPhoneEntry.Canada',
        shortName: 'CA',
        code: '+1'
    },
    usCountryCode
];

export const findCountryCode = (options: { countryCode?: string; shortName?: string } = {}): CountryCode => {
    let found;

    const optionKeys = Object.keys(options).filter(Boolean);

    if (optionKeys.length === 0) {
        found = usCountryCode;
    } else if (options.countryCode === usCountryCode.code || options.shortName === usCountryCode.shortName) {
        found = usCountryCode;
    } else {
        found = countryCodes.find(countryCode => {
            return optionKeys.find(key => countryCode[key] === options[key]);
        });
    }

    return found || usCountryCode;
};

/*
// All country codes
{
    country: 'Afghanistan',
    shortName: 'AF',
    code: '+93'
},
{
    country: 'Aland Islands',
    shortName: 'AX',
    code: '+358'
},
{
    country: 'Albania',
    shortName: 'AL',
    code: '+355'
},
{
    country: 'Algeria',
    shortName: 'DZ',
    code: '+213'
},
{
    country: 'American Samoa',
    shortName: 'AS',
    code: '+1684'
},
{
    country: 'Andorra',
    shortName: 'AD',
    code: '+376'
},
{
    country: 'Angola',
    shortName: 'AO',
    code: '+244'
},
{
    country: 'Anguilla',
    shortName: 'AI',
    code: '+1264'
},
{
    country: 'Antarctica',
    shortName: 'AQ',
    code: '+672'
},
{
    country: 'Antigua & Barbuda',
    shortName: 'AG',
    code: '+1268'
},
{
    country: 'Argentina',
    shortName: 'AR',
    code: '+54'
},
{
    country: 'Armenia',
    shortName: 'AM',
    code: '+374'
},
{
    country: 'Aruba',
    shortName: 'AW',
    code: '+297'
},
{
    country: 'Australia',
    shortName: 'AU',
    code: '+61'
},
{
    country: 'Austria',
    shortName: 'AT',
    code: '+43'
},
{
    country: 'Azerbaijan',
    shortName: 'AZ',
    code: '+994'
},
{
    country: 'Bahamas',
    shortName: 'BS',
    code: '+1242'
},
{
    country: 'Bahrain',
    shortName: 'BH',
    code: '+973'
},
{
    country: 'Bangladesh',
    shortName: 'BD',
    code: '+880'
},
{
    country: 'Barbados',
    shortName: 'BB',
    code: '+1246'
},
{
    country: 'Belarus',
    shortName: 'BY',
    code: '+375'
},
{
    country: 'Belgium',
    shortName: 'BE',
    code: '+32'
},
{
    country: 'Belize',
    shortName: 'BZ',
    code: '+501'
},
{
    country: 'Benin',
    shortName: 'BJ',
    code: '+229'
},
{
    country: 'Bermuda',
    shortName: 'BM',
    code: '+1441'
},
{
    country: 'Bhutan',
    shortName: 'BT',
    code: '+975'
},
{
    country: 'Bolivia',
    shortName: 'BO',
    code: '+591'
},
{
    country: 'Bosnia',
    shortName: 'BA',
    code: '+387'
},
{
    country: 'Botswana',
    shortName: 'BW',
    code: '+267'
},
{
    country: 'Brazil',
    shortName: 'BR',
    code: '+55'
},
{
    country: 'British Virgin Islands',
    shortName: 'VG',
    code: '+1284'
},
{
    country: 'Brunei',
    shortName: 'BN',
    code: '+673'
},
{
    country: 'Bulgaria',
    shortName: 'BG',
    code: '+359'
},
{
    country: 'Burkina Faso',
    shortName: 'BF',
    code: '+226'
},
{
    country: 'Burundi',
    shortName: 'BI',
    code: '+257'
},
{
    country: 'Cambodia',
    shortName: 'KH',
    code: '+855'
},
{
    country: 'Cameroon',
    shortName: 'CM',
    code: '+237'
},
{
    country: 'Canada',
    shortName: 'CA',
    code: '+1'
},
{
    country: 'Cape Verde',
    shortName: 'CV',
    code: '+238'
},
{
    country: 'Cayman Islands',
    shortName: 'KY',
    code: '+1345'
},
{
    country: 'Central African Republic',
    shortName: 'CF',
    code: '+236'
},
{
    country: 'Chad',
    shortName: 'TD',
    code: '+235'
},
{
    country: 'Chile',
    shortName: 'CL',
    code: '+56'
},
{
    country: 'China',
    shortName: 'CN',
    code: '+86'
},
{
    country: 'Christmas Island',
    shortName: 'CX',
    code: '+61'
},
{
    country: 'Cocos (Keeling) Islands',
    shortName: 'CC',
    code: '+61'
},
{
    country: 'Colombia',
    shortName: 'CO',
    code: '+57'
},
{
    country: 'Comoros',
    shortName: 'KM',
    code: '+269'
},
{
    country: 'Congo - Brazzaville',
    shortName: 'CG',
    code: '+242'
},
{
    country: 'Congo - Kinshasa',
    shortName: 'CD',
    code: '+243'
},
{
    country: 'Cook Islands',
    shortName: 'CK',
    code: '+682'
},
{
    country: 'Costa Rica',
    shortName: 'CR',
    code: '+506'
},
{
    country: 'Croatia',
    shortName: 'HR',
    code: '+385'
},
{
    country: 'Cuba',
    shortName: 'CU',
    code: '+53'
},
{
    country: 'Cyprus',
    shortName: 'CY',
    code: '+357'
},
{
    country: 'Czechia',
    shortName: 'CZ',
    code: '+420'
},
{
    country: 'Côte d’Ivoire',
    shortName: 'CI',
    code: '+225'
},
{
    country: 'Denmark',
    shortName: 'DK',
    code: '+45'
},
{
    country: 'Djibouti',
    shortName: 'DJ',
    code: '+253'
},
{
    country: 'Dominica',
    shortName: 'DM',
    code: '+1767'
},
{
    country: 'Dominican Republic',
    shortName: 'DO',
    code: '+1829'
},
{
    country: 'Ecuador',
    shortName: 'EC',
    code: '+593'
},
{
    country: 'Egypt',
    shortName: 'EG',
    code: '+20'
},
{
    country: 'El Salvador',
    shortName: 'SV',
    code: '+503'
},
{
    country: 'Equatorial Guinea',
    shortName: 'GQ',
    code: '+240'
},
{
    country: 'Eritrea',
    shortName: 'ER',
    code: '+291'
},
{
    country: 'Estonia',
    shortName: 'EE',
    code: '+372'
},
{
    country: 'Eswatini',
    shortName: 'SZ',
    code: '+268'
},
{
    country: 'Ethiopia',
    shortName: 'ET',
    code: '+251'
},
{
    country: 'Falkland Islands',
    shortName: 'FK',
    code: '+500'
},
{
    country: 'Faroe Islands',
    shortName: 'FO',
    code: '+298'
},
{
    country: 'Fiji',
    shortName: 'FJ',
    code: '+679'
},
{
    country: 'Finland',
    shortName: 'FI',
    code: '+358'
},
{
    country: 'France',
    shortName: 'FR',
    code: '+33'
},
{
    country: 'French Guiana',
    shortName: 'GF',
    code: '+594'
},
{
    country: 'French Polynesia',
    shortName: 'PF',
    code: '+689'
},
{
    country: 'French Southern Territories',
    shortName: 'TF',
    code: '+262'
},
{
    country: 'Gabon',
    shortName: 'GA',
    code: '+241'
},
{
    country: 'Gambia',
    shortName: 'GM',
    code: '+220'
},
{
    country: 'Georgia',
    shortName: 'GE',
    code: '+995'
},
{
    country: 'Germany',
    shortName: 'DE',
    code: '+49'
},
{
    country: 'Ghana',
    shortName: 'GH',
    code: '+233'
},
{
    country: 'Gibraltar',
    shortName: 'GI',
    code: '+350'
},
{
    country: 'Greece',
    shortName: 'GR',
    code: '+30'
},
{
    country: 'Greenland',
    shortName: 'GL',
    code: '+299'
},
{
    country: 'Grenada',
    shortName: 'GD',
    code: '+1473'
},
{
    country: 'Guadeloupe',
    shortName: 'GP',
    code: '+590'
},
{
    country: 'Guam',
    shortName: 'GU',
    code: '+1671'
},
{
    country: 'Guatemala',
    shortName: 'GT',
    code: '+502'
},
{
    country: 'Guernsey',
    shortName: 'GG',
    code: '+44'
},
{
    country: 'Guinea',
    shortName: 'GN',
    code: '+224'
},
{
    country: 'Guinea-Bissau',
    shortName: 'GW',
    code: '+245'
},
{
    country: 'Guyana',
    shortName: 'GY',
    code: '+592'
},
{
    country: 'Haiti',
    shortName: 'HT',
    code: '+509'
},
{
    country: 'Honduras',
    shortName: 'HN',
    code: '+504'
},
{
    country: 'Hong Kong',
    shortName: 'HK',
    code: '+852'
},
{
    country: 'Hungary',
    shortName: 'HU',
    code: '+36'
},
{
    country: 'Iceland',
    shortName: 'IS',
    code: '+354'
},
{
    country: 'India',
    shortName: 'IN',
    code: '+91'
},
{
    country: 'Indonesia',
    shortName: 'ID',
    code: '+62'
},
{
    country: 'Iran',
    shortName: 'IR',
    code: '+98'
},
{
    country: 'Iraq',
    shortName: 'IQ',
    code: '+964'
},
{
    country: 'Ireland',
    shortName: 'IE',
    code: '+353'
},
{
    country: 'Isle of Man',
    shortName: 'IM',
    code: '+44'
},
{
    country: 'Israel',
    shortName: 'IL',
    code: '+972'
},
{
    country: 'Italy',
    shortName: 'IT',
    code: '+39'
},
{
    country: 'Jamaica',
    shortName: 'JM',
    code: '+1876'
},
{
    country: 'Japan',
    shortName: 'JP',
    code: '+81'
},
{
    country: 'Jersey',
    shortName: 'JE',
    code: '+44'
},
{
    country: 'Jordan',
    shortName: 'JO',
    code: '+962'
},
{
    country: 'Kazakhstan',
    shortName: 'KZ',
    code: '+7'
},
{
    country: 'Kenya',
    shortName: 'KE',
    code: '+254'
},
{
    country: 'Kiribati',
    shortName: 'KI',
    code: '+686'
},
{
    country: 'Kuwait',
    shortName: 'KW',
    code: '+965'
},
{
    country: 'Kyrgyzstan',
    shortName: 'KG',
    code: '+996'
},
{
    country: 'Laos',
    shortName: 'LA',
    code: '+856'
},
{
    country: 'Latvia',
    shortName: 'LV',
    code: '+371'
},
{
    country: 'Lebanon',
    shortName: 'LB',
    code: '+961'
},
{
    country: 'Lesotho',
    shortName: 'LS',
    code: '+266'
},
{
    country: 'Liberia',
    shortName: 'LR',
    code: '+231'
},
{
    country: 'Libya',
    shortName: 'LY',
    code: '+218'
},
{
    country: 'Liechtenstein',
    shortName: 'LI',
    code: '+423'
},
{
    country: 'Lithuania',
    shortName: 'LT',
    code: '+370'
},
{
    country: 'Luxembourg',
    shortName: 'LU',
    code: '+352'
},
{
    country: 'Macao',
    shortName: 'MO',
    code: '+853'
},
{
    country: 'Madagascar',
    shortName: 'MG',
    code: '+261'
},
{
    country: 'Malawi',
    shortName: 'MW',
    code: '+265'
},
{
    country: 'Malaysia',
    shortName: 'MY',
    code: '+60'
},
{
    country: 'Maldives',
    shortName: 'MV',
    code: '+960'
},
{
    country: 'Mali',
    shortName: 'ML',
    code: '+223'
},
{
    country: 'Malta',
    shortName: 'MT',
    code: '+356'
},
{
    country: 'Marshall Islands',
    shortName: 'MH',
    code: '+692'
},
{
    country: 'Martinique',
    shortName: 'MQ',
    code: '+596'
},
{
    country: 'Mauritania',
    shortName: 'MR',
    code: '+222'
},
{
    country: 'Mauritius',
    shortName: 'MU',
    code: '+230'
},
{
    country: 'Mayotte',
    shortName: 'YT',
    code: '+262'
},
{
    country: 'Mexico',
    shortName: 'MX',
    code: '+52'
},
{
    country: 'Micronesia',
    shortName: 'FM',
    code: '+691'
},
{
    country: 'Moldova',
    shortName: 'MD',
    code: '+373'
},
{
    country: 'Monaco',
    shortName: 'MC',
    code: '+377'
},
{
    country: 'Mongolia',
    shortName: 'MN',
    code: '+976'
},
{
    country: 'Montenegro',
    shortName: 'ME',
    code: '+382'
},
{
    country: 'Montserrat',
    shortName: 'MS',
    code: '+1664'
},
{
    country: 'Morocco',
    shortName: 'MA',
    code: '+212'
},
{
    country: 'Mozambique',
    shortName: 'MZ',
    code: '+258'
},
{
    country: 'Myanmar',
    shortName: 'MM',
    code: '+95'
},
{
    country: 'Namibia',
    shortName: 'NA',
    code: '+264'
},
{
    country: 'Nepal',
    shortName: 'NP',
    code: '+977'
},
{
    country: 'Netherlands',
    shortName: 'NL',
    code: '+31'
},
{
    country: 'New Caledonia',
    shortName: 'NC',
    code: '+687'
},
{
    country: 'New Zealand',
    shortName: 'NZ',
    code: '+64'
},
{
    country: 'Nicaragua',
    shortName: 'NI',
    code: '+505'
},
{
    country: 'Niger',
    shortName: 'NE',
    code: '+227'
},
{
    country: 'Nigeria',
    shortName: 'NG',
    code: '+234'
},
{
    country: 'Niue',
    shortName: 'NU',
    code: '+683'
},
{
    country: 'Norfolk Island',
    shortName: 'NF',
    code: '+672'
},
{
    country: 'North Macedonia',
    shortName: 'MK',
    code: '+389'
},
{
    country: 'Norway',
    shortName: 'NO',
    code: '+47'
},
{
    country: 'Oman',
    shortName: 'OM',
    code: '+968'
},
{
    country: 'Pakistan',
    shortName: 'PK',
    code: '+92'
},
{
    country: 'Palau',
    shortName: 'PW',
    code: '+680'
},
{
    country: 'Palestine',
    shortName: 'PS',
    code: '+970'
},
{
    country: 'Panama',
    shortName: 'PA',
    code: '+507'
},
{
    country: 'Papua New Guinea',
    shortName: 'PG',
    code: '+675'
},
{
    country: 'Paraguay',
    shortName: 'PY',
    code: '+595'
},
{
    country: 'Peru',
    shortName: 'PE',
    code: '+51'
},
{
    country: 'Philippines',
    shortName: 'PH',
    code: '+63'
},
{
    country: 'Poland',
    shortName: 'PL',
    code: '+48'
},
{
    country: 'Portugal',
    shortName: 'PT',
    code: '+351'
},
{
    country: 'Puerto Rico',
    shortName: 'PR',
    code: '+1'
},
{
    country: 'Qatar',
    shortName: 'QA',
    code: '+974'
},
{
    country: 'Romania',
    shortName: 'RO',
    code: '+40'
},
{
    country: 'Russia',
    shortName: 'RU',
    code: '+7'
},
{
    country: 'Rwanda',
    shortName: 'RW',
    code: '+250'
},
{
    country: 'Réunion',
    shortName: 'RE',
    code: '+262'
},
{
    country: 'Samoa',
    shortName: 'WS',
    code: '+685'
},
{
    country: 'San Marino',
    shortName: 'SM',
    code: '+378'
},
{
    country: 'Saudi Arabia',
    shortName: 'SA',
    code: '+966'
},
{
    country: 'Senegal',
    shortName: 'SN',
    code: '+221'
},
{
    country: 'Serbia',
    shortName: 'RS',
    code: '+381'
},
{
    country: 'Seychelles',
    shortName: 'SC',
    code: '+248'
},
{
    country: 'Sierra Leone',
    shortName: 'SL',
    code: '+232'
},
{
    country: 'Singapore',
    shortName: 'SG',
    code: '+65'
},
{
    country: 'Slovakia',
    shortName: 'SK',
    code: '+421'
},
{
    country: 'Slovenia',
    shortName: 'SI',
    code: '+386'
},
{
    country: 'Solomon Islands',
    shortName: 'SB',
    code: '+677'
},
{
    country: 'Somalia',
    shortName: 'SO',
    code: '+252'
},
{
    country: 'South Africa',
    shortName: 'ZA',
    code: '+27'
},
{
    country: 'South Korea',
    shortName: 'KR',
    code: '+82'
},
{
    country: 'South Sudan',
    shortName: 'SS',
    code: '+211'
},
{
    country: 'Spain',
    shortName: 'ES',
    code: '+34'
},
{
    country: 'Sri Lanka',
    shortName: 'LK',
    code: '+94'
},
{
    country: 'St. Kitts & Nevis',
    shortName: 'KN',
    code: '+1869'
},
{
    country: 'St. Pierre & Miquelon',
    shortName: 'PM',
    code: '+508'
},
{
    country: 'St. Vincent & Grenadines',
    shortName: 'VC',
    code: '+1784'
},
{
    country: 'Sudan',
    shortName: 'SD',
    code: '+249'
},
{
    country: 'Suriname',
    shortName: 'SR',
    code: '+597'
},
{
    country: 'Svalbard & Jan Mayen',
    shortName: 'SJ',
    code: '+47'
},
{
    country: 'Sweden',
    shortName: 'SE',
    code: '+46'
},
{
    country: 'Switzerland',
    shortName: 'CH',
    code: '+41'
},
{
    country: 'Syria',
    shortName: 'SY',
    code: '+963'
},
{
    country: 'São Tomé & Príncipe',
    shortName: 'ST',
    code: '+239'
},
{
    country: 'Taiwan',
    shortName: 'TW',
    code: '+886'
},
{
    country: 'Tajikistan',
    shortName: 'TJ',
    code: '+992'
},
{
    country: 'Tanzania',
    shortName: 'TZ',
    code: '+255'
},
{
    country: 'Thailand',
    shortName: 'TH',
    code: '+66'
},
{
    country: 'Timor-Leste',
    shortName: 'TL',
    code: '+670'
},
{
    country: 'Togo',
    shortName: 'TG',
    code: '+228'
},
{
    country: 'Tonga',
    shortName: 'TO',
    code: '+676'
},
{
    country: 'Trinidad & Tobago',
    shortName: 'TT',
    code: '+1868'
},
{
    country: 'Tunisia',
    shortName: 'TN',
    code: '+216'
},
{
    country: 'Turkey',
    shortName: 'TR',
    code: '+90'
},
{
    country: 'Turkmenistan',
    shortName: 'TM',
    code: '+993'
},
{
    country: 'U.S. Virgin Islands',
    shortName: 'VI',
    code: '+1340'
},
{
    country: 'United Kingdom',
    shortName: 'GB',
    code: '+44'
},
{
    country: 'United States of America',
    shortName: 'US',
    code: '+1'
},
{
    country: 'Uganda',
    shortName: 'UG',
    code: '+256'
},
{
    country: 'Ukraine',
    shortName: 'UA',
    code: '+380'
},
{
    country: 'United Arab Emirates',
    shortName: 'AE',
    code: '+971'
},
{
    country: 'Uruguay',
    shortName: 'UY',
    code: '+598'
},
{
    country: 'Uzbekistan',
    shortName: 'UZ',
    code: '+998'
},
{
    country: 'Vanuatu',
    shortName: 'VU',
    code: '+678'
},
{
    country: 'Venezuela',
    shortName: 'VE',
    code: '+58'
},
{
    country: 'Vietnam',
    shortName: 'VN',
    code: '+84'
},
{
    country: 'Wallis & Futuna',
    shortName: 'WF',
    code: '+681'
},
{
    country: 'Western Sahara',
    shortName: 'EH',
    code: '+212'
},
{
    country: 'Yemen',
    shortName: 'YE',
    code: '+967'
},
{
    country: 'Zambia',
    shortName: 'ZM',
    code: '+260'
},
{
    country: 'Zimbabwe',
    shortName: 'ZW',
    code: '+263'
}
*/
